export const replaceWindowState = (url: string) => {
    window.history.replaceState(null, "", url);

    window.dispatchEvent(new PopStateEvent("popstate"));
};
